import { render, staticRenderFns } from "./CustomerSearchContactsResultModal.vue?vue&type=template&id=0b646167"
import script from "./CustomerSearchContactsResultModal.vue?vue&type=script&lang=js"
export * from "./CustomerSearchContactsResultModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports